<app-feedback
  [message]="feedback.message"
  [theme]="feedback.theme"
></app-feedback>

<div class="page page-document">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="document-breadcrumb">
          <ul class="document-nav">
            <li [ngClass]="stepClass(STEP_BUILD)"><span>Informações</span></li>
            <li [ngClass]="stepClass(STEP_REVIEW)"><span>Preparação</span></li>
            <li [ngClass]="stepClass(STEP_FINISH)"><span>Envio</span></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="steps"><router-outlet></router-outlet></div>
  </div>
</div>
